import { Link } from "react-router-dom";
import { Button, Card, CardContent } from "@/components/primitives";
import { Calendar, Plus } from "lucide-react";

export const EmptyState = () => {
	return (
		<Card className="border-2 shadow-xl bg-white/90 dark:bg-slate-800/90 backdrop-blur-sm">
			<CardContent className="text-center py-12">
				<div className="p-3 rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 w-16 h-16 mx-auto mb-4 flex items-center justify-center">
					<Calendar className="h-8 w-8 text-white" />
				</div>
				<h3 className="text-xl font-semibold text-foreground mb-2">
					No check-ins yet
				</h3>
				<p className="text-muted-foreground mb-6 max-w-md mx-auto">
					Start tracking your daily progress and mood patterns to see your
					journey unfold.
				</p>
				<Link to="/daily-checkin/welcome">
					<Button className="bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-600 hover:to-indigo-700 text-white shadow-md hover:shadow-lg transition-all">
						<Plus className="h-4 w-4 mr-2" />
						Add your first check-in
					</Button>
				</Link>
			</CardContent>
		</Card>
	);
};
